{
  "longPressMessage": "Langt trykk for å åpne forhåndsvisningen"
}
